import { useState, useEffect } from 'react';
import { Element, scroller } from 'react-scroll';
import { searchContext } from '../../context/Context';
import ManageGrid from '../../modules/search/searchGrid/components/table/ManageGrid';
import { getAllColumns } from '../Table/columns/index';
import { isEvidenceOnlyMapping, isSummaryOnlyMapping } from '../../config/mappingRules';
import { getDefaultEvidenceFiltersForMapping } from '../../utils/mappingDefaultEvidenceFilters';

function MappingResults({ mappingContent, dispatch }) {
  const { view, source, tab, setSearchItems } = searchContext();
  const [isInfoSidebarOpen, setIsInfoSidebarOpen] = useState(false);

  const column = getAllColumns().find(c => c.name === mappingContent.name);
  const title = column?.header?.props?.children || column?.header || mappingContent.name;

  const getDefaultEvidenceFilterValue = getDefaultEvidenceFiltersForMapping;

  const evidenceOnly = isEvidenceOnlyMapping(mappingContent?.name);
  const summaryOnly = isSummaryOnlyMapping(mappingContent?.name);
  const showSummary = !evidenceOnly;
  const showEvidence = !summaryOnly;

  useEffect(() => {
    const target = showSummary ? 'MappingSummary' : 'MappingEvidence';
    scroller.scrollTo(target, {
      duration: 800,
      delay: 0,
      smooth: 'easeInOutQuart',
    });
  }, [mappingContent, showSummary]);

  return (
    <>
      <div className="titEtiqueta pt-12">
        <span>{title} Mapping</span>
      </div>
      <Element name="MappingSummary">
        {showSummary && mappingContent?.mappingItems && (
          <ManageGrid
            view={view}
            source={source}
            tab={tab}
            searchItems={mappingContent?.mappingItems}
            setSearchItems={setSearchItems}
            isEvidence={false}
            isMapping={true}
            isInfoSidebarOpen={isInfoSidebarOpen}
            mappingContent={mappingContent}
            setIsInfoSidebarOpen={setIsInfoSidebarOpen}
            dispatch={dispatch}
            restrictChemical={false}
          />
        )}
      </Element>
      <Element name="MappingEvidence">
        {showEvidence && (
          <ManageGrid
            view={view}
            source={source}
            tab={tab}
            searchItems={mappingContent?.mappingItems}
            setSearchItems={setSearchItems}
            isEvidence={true}
            isMapping={true}
            setIsInfoSidebarOpen={setIsInfoSidebarOpen}
            mappingContent={mappingContent}
            isInfoSidebarOpen={isInfoSidebarOpen}
            dispatch={dispatch}
            restrictChemical={false}
            defaultFilterValue={getDefaultEvidenceFilterValue(mappingContent)}
          />
        )}
      </Element>
    </>
  );
}
export default MappingResults;
